export default __webpack_public_path__ + "static/media/discount.7944a384.png";